<template>
  <el-form-item
    :label="item.label"
    :prop="`${item.field}`"
    :hidden="item.options.hidden"
    v-if="item.showed"
    :rules="[
      {
        required: item.required || false,
        message: item.label + '为必填字段',
      },
    ]"
  >
    <el-input
      type="textarea"
      :style="{ width: item.options.width }"
      :rows="item.options.rows || 3"
      v-model="$attrs.model[item.field]"
      :placeholder="item.options.placeholder"
      :disabled="item.options.disabled"
      :maxlength="item.options.maxlength"
      resize="none"
      show-word-limit
    >
    </el-input>
  </el-form-item>
</template>

<script>
export default {
  props: {
    item: Object,
  },
};
</script>

<style lang="scss" scoped></style>
